import styled from "styled-components";

export const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 10px;
    height: 3rem;
    width: 12rem;
    background: var(--orange);
    font-size: 12px;  
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    color: var(--btn-text);
`